import { loadScript } from '@naturalcycles/js-lib';
/**
 * @description
 * Read more about what this code does here: https://developers.google.com/tag-platform/devguides/conversions
 * Please note that this tag can be used by several google conversion / analytics products (with different ids)
 */
export function googleTag(gtagId) {
  window.dataLayer ||= [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', gtagId, {
    // page_view event is triggered in the pageView method
    send_page_view: false
  });
  void loadScript(`https://www.googletagmanager.com/gtag/js?id=${gtagId}`);
}